<template>
  <div class="withd_body">

    <div class="beij">
      <div class="fangshi">
        <span style="font-size: 14px;color: #ccc">充值方式</span>
        <span style="font-size: 14px;font-weight: 500;position: absolute;right: 10px;">微信</span>
      </div>

      <div class="jine">
        <div class="chongzhijine">充值金额</div>
        <div class="shuru">
          <van-cell-group>
            <div class="qian">¥</div>
            <div>
              <van-field v-model="value" placeholder=""/>
            </div>
          </van-cell-group>
        </div>
      </div>

    </div>

    <div>
      <van-button type="primary" block @click="push">确定</van-button>
    </div>

  </div>
</template>

<script>
  import wx from 'weixin-js-sdk'

  export default {
    name: "withdrawal",
    data() {
      return {
        value: '',
      }
    },
    created() {
      console.log(wx)
    },
    methods: {
      push() {
        var that = this;
        this.myrequest({
          url: '/client/userchongzhis.action',
          types: 'post',
          data: {
            fee: this.value
          },
          succ: (res) => {
            wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: this.$store.state.appid, // 必填，公众号的唯一标识
              timestamp: this.$store.state.timestamp, // 必填，生成签名的时间戳
              nonceStr: this.$store.state.nonceStr, // 必填，生成签名的随机串
              signature: this.$store.state.signature,// 必填，签名
              jsApiList: ['chooseImage', 'updateAppMessageShareData', 'updateTimelineShareData', 'chooseWXPay'] // 必填，需要使用的JS接口列表
            });
            wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
              wx.chooseWXPay({
                timestamp: res.data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                nonceStr: res.data.nonceStr, // 支付签名随机串，不长于 32 位
                package: res.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                signType: 'MD5', // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                paySign: res.data.paySign, // 支付签名
                success: function (res) {
                  // window.location.href = '/index/Mine/confirmOrder/orderDetails?ids=' + this.orderId
                  Toast.success('充值成功!');
                  that.$route.back();
                },
                cancel: function (res) {
                  // alert('1234')
                  // alert(JSON.stringify(res))
                  Toast.success('已取消支付');
                },
                fail: function (res) {
                  // alert(12313)
                }
              });
            });

          },
          errs: (msg) => {

          }
        })
      }
    },
  }
</script>

<style scoped lang="stylus">
  .withd_body {
    position: absolute;
    width 100%;
    background-color #f1f1f1;
    height 100%;
    padding-top 10px;

    >>> .van-button--block {
      margin 10px auto;
      width 90%;
      border-radius 10px;
    }

    .beij {
      background-color #ffffff;
      width 95%;
      height 150px;
      margin auto;
      border-radius 10px;
    }

    .fangshi {
      position relative;
      height 40px;
      line-height 40px;
      margin-left 10px;
      margin-right 10px;
      border-bottom 1px solid #f4f4f4
    }

    .jine {

      .chongzhijine {
        font-size 16px;
        color #ccc;
        margin-left 10px;
        margin-top 10px;
      }

      .shuru {
        .qian {
          font-size 40px;
          width 8%;
          margin-left 10px;
        }
      }

      >>> .van-cell {
        width 80%;
        padding 0px;
        margin-left 10px;
        font-size 28px;
      }

      >>> .van-cell-group {
        display flex;
        width 100%;
        flex-direction: row;
        /*justify-content: center;*/
        align-items: center;
      }

      >>> .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
        border 0px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/wode/withdrawal.vue